import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AddressValidationResult } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'boels-address-validation',
  templateUrl: './address-validation.component.html',
  styleUrls: ['./address-validation.component.scss'],
  imports: [FontAwesomeModule, TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['address-validation'],
    },
  ],
})
export class AddressValidationComponent {
  circleExclamation = faCircleExclamation;

  @Input() addressValidationResult?: AddressValidationResult;

  @Output() replaceFields = new EventEmitter();

  replaceWithSuggestion(): void {
    this.replaceFields.emit(this.addressValidationResult);
    this.addressValidationResult = undefined;
  }

  getDictionaryKeys(dict: { [key: string]: unknown }): string[] {
    return Object.keys(dict);
  }
}
